import { Resource } from '@ngxp/rest';
import { KontaktKategorie, KontaktResource } from '@schir-int-client/adressverwaltung-shared';
import { RegisterName } from '@schir-int-client/register-shared';
import { ListResource } from '@schir-int-client/ngrx-helpers';
import { AufgabeListLinkRel } from './aufgabe.linkrel';
import { AdressatListLinkRel } from './adressat/adressat.linkrel';

export enum AufgabenTyp {
	FINANZSANKTIONSLISTE = 'FINANZSANKTIONSLISTE',
	ZERTIFIKAT = 'ZERTIFIKAT', // deprecated: neu SCHIFFSBRIEF bzw. SCHIFFSZERTIFIKAT je nach Register
	SCHIFFSBRIEF = 'SCHIFFSBRIEF',
	ALTER_SCHIFFSBRIEF = 'ALTER_SCHIFFSBRIEF',
	SCHIFFSZERTIFIKAT = 'SCHIFFSZERTIFIKAT',
	ALTES_ZERTIFIKAT = 'ALTES_ZERTIFIKAT',
	ZERTIFIKATSAUSZUG = 'ZERTIFIKATSAUSZUG',
	ABSCHRIFT_ZERTIFIKATSAUSZUG = 'ABSCHRIFT_ZERTIFIKATSAUSZUG',
	ALTER_AUSZUG = 'ALTER_AUSZUG',
	HYPOTHEKENBESCHEINIGUNG = 'HYPOTHEKENBESCHEINIGUNG',
	EIGENTUEMERBESCHEINIGUNG = 'EIGENTUEMERBESCHEINIGUNG',
	LOESCHUNGSBESCHEINIGUNG = 'LOESCHUNGSBESCHEINIGUNG',
	LASTENFREIHEITSBESCHEINIGUNG = 'LASTENFREIHEITSBESCHEINIGUNG',
	NAMENSAENDERUNGSBESCHEINIGUNG = 'NAMENSAENDERUNGSBESCHEINIGUNG',
	REGISTERABSCHRIFT = 'REGISTERABSCHRIFT',
	EINTRAGUNGSMITTEILUNG = 'EINTRAGUNGSMITTEILUNG',
	MESSBRIEF = 'MESSBRIEF',
	VERMESSUNGSURKUNDE = 'VERMESSUNGSURKUNDE',
	SONSTIGE = 'SONSTIGE',
	RECHNUNGSSTELLUNG = 'RECHNUNGSSTELLUNG',
	KOSTEN = 'KOSTEN',
	STATISTIK = 'STATISTIK',
	HEIMATHAFENVERLEGUNG = 'HEIMATHAFENVERLEGUNG',
	HEIMATORTVERLEGUNG = 'HEIMATORTVERLEGUNG',
	WIEDERVORLAGE = 'WIEDERVORLAGE',
	ABLAGE = 'ABLAGE',
	ANSCHREIBEN = 'ANSCHREIBEN',
	LFPR_REGISTERAKTE_ANLEGEN = 'LFPR_REGISTERAKTE_ANLEGEN',
	LFPR_SCHULDTITEL = 'LFPR_SCHULDTITEL',
	LFPR_MITTEILUNG = 'LFPR_MITTEILUNG',
	LFPR_STATISTIK = 'LFPR_STATISTIK',
	LFPR_VERWEISUNGSVERMERK = 'LFPR_VERWEISUNGSVERMERK',
	LFPR_DB_AKTUALISIEREN = 'LFPR_DB_AKTUALISIEREN',
	LFPR_BLATTABSCHRIFT = 'LFPR_BLATTABSCHRIFT',
	LFPR_NEGATIVBESCHEINIGUNG = 'LFPR_NEGATIVBESCHEINIGUNG',
	LFPR_KOSTEN = 'LFPR_KOSTEN',
	LFPR_WIEDERVORLAGE = 'LFPR_WIEDERVORLAGE',
	LFPR_ERLEDIGT = 'LFPR_ERLEDIGT',
	LFPR_WEGLEGEN = 'LFPR_WEGLEGEN',
	LFPR_SAMMLUNG = 'LFPR_SAMMLUNG',
}

const AUFGABEN_TYPEN_MAP: Record<RegisterName, (isLFPR?: boolean) => AufgabenTyp[]> = {
	[RegisterName.SSR]: () => [
		AufgabenTyp.FINANZSANKTIONSLISTE,
		AufgabenTyp.SCHIFFSZERTIFIKAT,
		AufgabenTyp.ALTES_ZERTIFIKAT,
		AufgabenTyp.ZERTIFIKATSAUSZUG,
		AufgabenTyp.ABSCHRIFT_ZERTIFIKATSAUSZUG,
		AufgabenTyp.ALTER_AUSZUG,
		AufgabenTyp.HYPOTHEKENBESCHEINIGUNG,
		AufgabenTyp.EIGENTUEMERBESCHEINIGUNG,
		AufgabenTyp.LOESCHUNGSBESCHEINIGUNG,
		AufgabenTyp.LASTENFREIHEITSBESCHEINIGUNG,
		AufgabenTyp.NAMENSAENDERUNGSBESCHEINIGUNG,
		AufgabenTyp.REGISTERABSCHRIFT,
		AufgabenTyp.EINTRAGUNGSMITTEILUNG,
		AufgabenTyp.MESSBRIEF,
		AufgabenTyp.SONSTIGE,
		AufgabenTyp.RECHNUNGSSTELLUNG,
		AufgabenTyp.KOSTEN,
		AufgabenTyp.STATISTIK,
		AufgabenTyp.HEIMATHAFENVERLEGUNG,
		AufgabenTyp.WIEDERVORLAGE,
		AufgabenTyp.ABLAGE,
		AufgabenTyp.ANSCHREIBEN,
	],
	[RegisterName.BSR]: () => [
		AufgabenTyp.FINANZSANKTIONSLISTE,
		AufgabenTyp.SCHIFFSBRIEF,
		AufgabenTyp.ALTER_SCHIFFSBRIEF,
		AufgabenTyp.HYPOTHEKENBESCHEINIGUNG,
		AufgabenTyp.EIGENTUEMERBESCHEINIGUNG,
		AufgabenTyp.LOESCHUNGSBESCHEINIGUNG,
		AufgabenTyp.LASTENFREIHEITSBESCHEINIGUNG,
		AufgabenTyp.NAMENSAENDERUNGSBESCHEINIGUNG,
		AufgabenTyp.REGISTERABSCHRIFT,
		AufgabenTyp.EINTRAGUNGSMITTEILUNG,
		AufgabenTyp.VERMESSUNGSURKUNDE,
		AufgabenTyp.SONSTIGE,
		AufgabenTyp.RECHNUNGSSTELLUNG,
		AufgabenTyp.KOSTEN,
		AufgabenTyp.STATISTIK,
		AufgabenTyp.HEIMATORTVERLEGUNG,
		AufgabenTyp.WIEDERVORLAGE,
		AufgabenTyp.ABLAGE,
		AufgabenTyp.ANSCHREIBEN,
	],
	[RegisterName.SBR]: () => [
		AufgabenTyp.FINANZSANKTIONSLISTE,
		AufgabenTyp.HYPOTHEKENBESCHEINIGUNG,
		AufgabenTyp.EIGENTUEMERBESCHEINIGUNG,
		AufgabenTyp.LOESCHUNGSBESCHEINIGUNG,
		AufgabenTyp.LASTENFREIHEITSBESCHEINIGUNG,
		AufgabenTyp.NAMENSAENDERUNGSBESCHEINIGUNG,
		AufgabenTyp.REGISTERABSCHRIFT,
		AufgabenTyp.EINTRAGUNGSMITTEILUNG,
		AufgabenTyp.SONSTIGE,
		AufgabenTyp.RECHNUNGSSTELLUNG,
		AufgabenTyp.KOSTEN,
		AufgabenTyp.STATISTIK,
		AufgabenTyp.WIEDERVORLAGE,
		AufgabenTyp.ABLAGE,
		AufgabenTyp.ANSCHREIBEN,
	],
	[RegisterName.LR]: () => Object.values(AufgabenTyp).filter(value => value.startsWith('LFPR_')),
	[RegisterName.ETL]: () => Object.values(AufgabenTyp).filter(value => value.startsWith('LFPR_')),
	[RegisterName.AR]: (isLFPR?: boolean) =>
		isLFPR
			? [
					AufgabenTyp.LFPR_REGISTERAKTE_ANLEGEN,
					AufgabenTyp.LFPR_SCHULDTITEL,
					AufgabenTyp.LFPR_STATISTIK,
					AufgabenTyp.LFPR_VERWEISUNGSVERMERK,
					AufgabenTyp.LFPR_DB_AKTUALISIEREN,
					AufgabenTyp.LFPR_NEGATIVBESCHEINIGUNG,
					AufgabenTyp.LFPR_KOSTEN,
					AufgabenTyp.LFPR_WIEDERVORLAGE,
					AufgabenTyp.LFPR_ERLEDIGT,
					AufgabenTyp.LFPR_WEGLEGEN,
					AufgabenTyp.LFPR_SAMMLUNG,
				]
			: [
					AufgabenTyp.FINANZSANKTIONSLISTE,
					AufgabenTyp.HYPOTHEKENBESCHEINIGUNG,
					AufgabenTyp.EIGENTUEMERBESCHEINIGUNG,
					AufgabenTyp.LOESCHUNGSBESCHEINIGUNG,
					AufgabenTyp.LASTENFREIHEITSBESCHEINIGUNG,
					AufgabenTyp.NAMENSAENDERUNGSBESCHEINIGUNG,
					AufgabenTyp.VERMESSUNGSURKUNDE,
					AufgabenTyp.SONSTIGE,
					AufgabenTyp.RECHNUNGSSTELLUNG,
					AufgabenTyp.KOSTEN,
					AufgabenTyp.STATISTIK,
					AufgabenTyp.WIEDERVORLAGE,
					AufgabenTyp.ABLAGE,
					AufgabenTyp.ANSCHREIBEN,
				],
};

export function aufgabenTypenForRegister(register: RegisterName, isLFPR: boolean): AufgabenTyp[] {
	const provideAufgabenTypen = AUFGABEN_TYPEN_MAP[register];
	return provideAufgabenTypen ? provideAufgabenTypen(isLFPR) : [];
}

export enum AufgabeStatus {
	NEU = 'NEU',
	FREIGEGEBEN = 'FREIGEGEBEN',
	ERLEDIGT = 'ERLEDIGT',
}

export enum AufgabeZertifikatTaetigkeit {
	FERTIGEN = 'FERTIGEN',
	BERICHTIGEN = 'BERICHTIGEN',
	NACH_EINGANG_BERICHTIGEN = 'NACH_EINGANG_BERICHTIGEN',
	VORHANDEN = 'VORHANDEN',
	NOTIZ = 'NOTIZ',
}

export enum AufgabeVersandTaetigkeit {
	SENDEN_AN = 'SENDEN_AN',
	AUSHAENDIGEN_AN = 'AUSHAENDIGEN_AN',
}

export const aufgabeVersandTaetigkeiten = [
	AufgabeVersandTaetigkeit.SENDEN_AN,
	AufgabeVersandTaetigkeit.AUSHAENDIGEN_AN,
];

export enum AufgabeLfprKostenTaetigkeit {
	GEZAHLT = 'GEZAHLT',
	ERFORDERN = 'ERFORDERN',
	SOLL = 'SOLL',
	FREI = 'FREI',
}

export enum AufgabeLfprKostenTraeger {
	NOTAR = 'NOTAR',
	EIGENTUEMER = 'EIGENTUEMER',
	BERECHTIGTE = 'BERECHTIGTE',
	RECHTSANWALT = 'RECHTSANWALT',
	SONSTIGE = 'SONSTIGE',
}

export enum AufgabeLfprKostenfreiGrund {
	PARAGRAPH102 = 'PARAGRAPH102',
	GNOTKG = 'GNOTKG',
	GES = 'GES',
}

export enum AufgabeRechnungsstellungErledigung {
	ERLEDIGT = 'ERLEDIGT',
	SPAETER = 'SPAETER',
}

export interface Aufgabe {
	typ: AufgabenTyp;
	status: AufgabeStatus;
	notiz: string;
	adressaten: AdressatWithResource[];
	body:
		| AufgabeZertifikatBody
		| AufgabeVersandBody
		| AufgabeAbschriftBody
		| AufgabeWiedervorlageBody
		| AufgabeRechnungsstellungBody
		| AufgabeMitteilungBody
		| AufgabeAnschreibenBody;
}

export interface AufgabeZertifikatBody {
	taetigkeit: AufgabeZertifikatTaetigkeit;
	versandTaetigkeit: AufgabeVersandTaetigkeit;
	sendenAn: KontaktKategorie[];
	faxEmpfaenger?: KontaktKategorie[];
}

export interface AufgabeZertifikatsauszugBody {
	zertifikatTaetigkeit?: AufgabeZertifikatTaetigkeit;
	taetigkeit: AufgabeVersandTaetigkeit;
	empfaenger: KontaktKategorie[];
	faxEmpfaenger: KontaktKategorie[];
}

export interface AufgabeVersandBody {
	taetigkeit: AufgabeVersandTaetigkeit;
	empfaenger: KontaktKategorie[];
	faxEmpfaenger: KontaktKategorie[];
}

export interface AufgabeAbschriftBody {
	beglaubigte: number;
	einfache: number;
}

export interface AufgabeWiedervorlageBody {
	wiedervorlageDatum: Date;
}

export interface AufgabeRechnungsstellungBody {
	erledigung: AufgabeRechnungsstellungErledigung;
}

export interface AufgabeMitteilungBody {
	anEigentuemerNeuSenden: boolean;
	eigentuemerNeuMitteilung: AnEigentuemerZuSenden;

	anEigentuemerAltSenden: boolean;
	eigentuemerAltMitteilung: AnEigentuemerZuSenden;

	anEingetragenerEigentuemerSenden: boolean;
	eingetragenerEigentuemerMitteilung: AnEigentuemerZuSenden;

	anGlaeubigerNeuSenden: boolean;
	glaeubigerNeuMitteilung: AnGlaeubigerNeuZuSenden;

	anGlaeubigerAltSenden: boolean;
	glaeubigerAltMitteilung: AnGlaeubigerAltZuSenden;

	anNotarSenden: boolean;
	notarMitteilung: AnNotarZuSenden;

	anBehoerdenSenden: boolean;

	anBshSenden: boolean;
	bshMitteilung: AnBshZuSenden;

	anRechtsanwaelteSenden: boolean;
	rechtsanwaelteMitteilung: AnRechtsanwaelteZuSenden;
}

export interface AufgabeAnschreibenBody {
	vorlageId?: number;
	vorlageIds?: { [k: number]: number };
	rechtspfleger: string;
	datum: Date;
}

export interface AnEigentuemerZuSenden {
	blattabschrift: boolean;
	zertifikatsBerichtigung: boolean;
	auszugsEinreichung: boolean;
}

export interface AnGlaeubigerNeuZuSenden {
	blattabschrift: boolean;
	zertifikatsBerichtigung: boolean;
}

export interface AnGlaeubigerAltZuSenden {
	blattabschrift: boolean;
	zertifikatsBerichtigung: boolean;
}

export interface AnNotarZuSenden {
	blattabschrift: boolean;
}

export interface AnBshZuSenden {
	blattabschrift: boolean;
}

export interface AnRechtsanwaelteZuSenden {
	blattabschrift: boolean;
	zertifikatsBerichtigung: boolean;
}

export interface AufgabeResource extends Aufgabe, Resource {}

export interface AufgabeListResource extends ListResource<AufgabeResource, AufgabeListLinkRel.AUFGABE_LIST> {}

export interface Adressat {
	channelBrief: boolean;
	channelFax: boolean;
	channelEmail: boolean;
	channelAbholung: boolean;
	channelEgvp: boolean;
	notiz: string;
}

export interface AdressatDragData {
	kontaktId: number;
	name: string;
	vorname: string;
	firmenName: string;
}

export interface WithResource {
	resource: KontaktResource;
}

export interface AdressatWithResource extends AdressatResource, WithResource {}

export interface AdressatResource extends Adressat, Resource {}

export interface AdressatListResource extends ListResource<AdressatResource, AdressatListLinkRel.ADRESSAT_LIST> {}
